export default "__VITE_ASSET__079681b5__"